import React, { useState, createContext, useContext } from 'react';
interface OrderBumpContextType {
  isOrderBumpChecked: boolean;
  setIsOrderBumpChecked: (checked: boolean) => void;
  showPopup: boolean;
  setShowPopup: (show: boolean) => void;
}
const OrderBumpContext = createContext<OrderBumpContextType>({
  isOrderBumpChecked: false,
  setIsOrderBumpChecked: () => {},
  showPopup: false,
  setShowPopup: () => {}
});
export function useOrderBump() {
  return useContext(OrderBumpContext);
}
export function OrderBumpProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [isOrderBumpChecked, setIsOrderBumpChecked] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  return <OrderBumpContext.Provider value={{
    isOrderBumpChecked,
    setIsOrderBumpChecked,
    showPopup,
    setShowPopup
  }} data-id="element-294">
      {children}
    </OrderBumpContext.Provider>;
}